import { render, staticRenderFns } from "./PriceListDetailView.vue?vue&type=template&id=016bc7d2"
import script from "./PriceListDetailView.vue?vue&type=script&lang=js"
export * from "./PriceListDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports